import { render, staticRenderFns } from "./_categoria.vue?vue&type=template&id=71d7b5d7&scoped=true"
import script from "./_categoria.vue?vue&type=script&lang=js"
export * from "./_categoria.vue?vue&type=script&lang=js"
import style0 from "./_categoria.vue?vue&type=style&index=0&id=71d7b5d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7b5d7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsCategorySelected: require('/home/luiz/Sistemas/loja/components/ProductsCategorySelected.vue').default,InformationProductDescription: require('/home/luiz/Sistemas/loja/components/InformationProduct/Description.vue').default,InformationProductBenefits: require('/home/luiz/Sistemas/loja/components/InformationProduct/Benefits.vue').default,InformationProductImportantDocuments: require('/home/luiz/Sistemas/loja/components/InformationProduct/ImportantDocuments.vue').default})
